import _ from 'lodash'

import {
  FETCHING_MYD_ACTIVITIES,
  FETCHED_MYD_ACTIVITIES,
  FETCHING_MYD_ACTIVITY,
  FETCHED_MYD_ACTIVITY,
} from '_reducers/myd_activities'

import { MydAPI } from '_services/default'
import { CancelToken } from 'axios'
import { deserializeGeneric, deserializeRelationship } from 'utils/relationships'


function _fetchingMydActivities() {
  return { type: FETCHING_MYD_ACTIVITIES }
}

function _fetchedMydActivities(mydActivities, meta) {
  return { type: FETCHED_MYD_ACTIVITIES, mydActivities, meta }
}

function _fetchingMydActivity() {
  return { type: FETCHING_MYD_ACTIVITY }
}

function _fetchedMydActivity(mydActivity) {
  return { type: FETCHED_MYD_ACTIVITY, mydActivity }
}


export const deserializeMydActivity = (item, included) => {

  if (! _.has(item, 'relationships'))
    item.relationships = {}

  return {
    ...deserializeGeneric(item),
    mydCompetences: deserializeRelationship(item.relationships.mydCompetences, included),
    subjects: deserializeRelationship(item.relationships.subjects, included),
    language: deserializeRelationship(item.relationships.language, included),
    tags: deserializeRelationship(item.relationships.tags, included),
    educationLevels: deserializeRelationship(item.relationships.educationLevels, included),
    createdBy: deserializeRelationship(item.relationships.createdBy, included),
  }
}


let fetchMydActivitiesCancelToken = null

export const fetchMydActivities = (
  page=1, filters={},
  includes=[
    'myd_competences','subjects','language','tags','education_levels','created_by'
  ],
  fields=null,
) => {
  return dispatch => new Promise((resolve, reject) => {
    dispatch(_fetchingMydActivities())

    if (fetchMydActivitiesCancelToken)
      fetchMydActivitiesCancelToken()

    let _fields = {}
    if (fields)
      _fields = _.reduce(
        fields,
        (red, items, key) => {
          return {
            ...red,
            [`fields[${key}]`]: items.join(','),
          }
        },
        {}
      )

    MydAPI.get('/myd/activities',
      {
        cancelToken: new CancelToken(function executor(c) {
          fetchMydActivitiesCancelToken = c
        }),
        params: {
          'sort': '-modified_at',
          'page[size]': 30,
          'page[number]': page,
          include: _.join(includes, ','),
          ...filters,
          ..._fields,
        }
      }
    ).then(res => {
      let mydActivities = _.map(res.data.data, item => deserializeMydActivity(item, res.data.included))

      dispatch(_fetchedMydActivities(mydActivities, {
        maxPage:  _.ceil(res.data.meta.count / 30),
      }))
      resolve(mydActivities)

    }).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
}


export const fetchMydActivity = mydActivityId => (
  dispatch => new Promise((resolve, reject) => {

    dispatch(_fetchingMydActivity())

    MydAPI.get(`/myd/activities/${mydActivityId}?include=myd_competences,subjects,language,tags,education_levels,created_by`).then(
      res => {
        let mydActivity = deserializeMydActivity(res.data.data, res.data.included)
        dispatch(_fetchedMydActivity(mydActivity))
        resolve(mydActivity)
      }
    ).catch(err => {
      reject(err)
    })
  })
)


export const saveMydActivity = (_data, mydActivityId=false) => (
  dispatch => new Promise((resolve, reject) => {
    let url = `/myd/activities`
    let _method = MydAPI.post
    let data = {
      type: 'myd_activity',
      attributes: {
        title: _data.title,
        description: _.get(_data, 'description', ''),
        evaluation_criteria: _.get(_data, 'evaluationCriteria', ''),
        language_id: _.get(_data, 'languageId', false),
        image: _.get(_data, 'image', false),
        teaching_notes: _.get(_data, 'teachingNotes', false),
      },
      relationships: {
        subjects: {
          data: _.map(
            _.get(_data, 'subjects', []),
            item => ({
              type: 'subject',
              id: item,
            })
          ),
        },
        myd_competences: {
          data: _.map(
            _.get(_data, 'mydCompetences', []),
            item => ({
              type: 'myd_competence',
              id: item,
            })
          ),
        },
        tags: {
          data: _.map(
            _.get(_data, 'tags', []),
            item => ({
              type: 'myd_tag',
              id: item,
            })
          ),
        },
        education_levels: {
          data: _.map(
            _.get(_data, 'educationLevels', []),
            item => ({
              type: 'education_level',
              id: item,
            })
          ),
        },
      }
    }

    if (mydActivityId) {
      data.id = mydActivityId
      _method = MydAPI.patch
      url = `/myd/activities/${mydActivityId}`
    }

    _method(`${url}?include=subjects,language,myd_competences,education_levels,tags`, {data}).then(res => {
      resolve(deserializeMydActivity(res.data.data, res.data.included))
    }).catch(err => {
      reject(err)
    })
  })
)


let searchMydActivitiesCancelToken = null

export const searchMydActivities = (filters=[], page=1) => {
  return new Promise((resolve, reject) => {

    let _filters = _.reduce(filters, (ret, value, name) => {

      if ( ! value)
          return ret

      switch(name) {
        case 'search':
          return {
            ...ret,
            search: value,
          }
        case 'date':
          return {
            ...ret,
            date: value,
          }
        case 'subject':
          return {
            ...ret,
            subject: value,
          }
        case 'language_id':
          return {
            ...ret,
            language_id: value,
          }
        case 'education_level':
          return {
            ...ret,
            education_level: value,
          }
        default:
          return ret
      }
    },
    {})

    _filters = {
      ..._filters,
      'page[number]': page,
      include: 'myd_competences,subjects,language,tags,education_levels',
    }

    if (searchMydActivitiesCancelToken)
      searchMydActivitiesCancelToken()

    MydAPI.get(
      '/myd/activities',
      {
        params: _filters,
        cancelToken:  new CancelToken(function executor(c) {
          searchMydActivitiesCancelToken = c
        }),
      }
    ).then(res => {
      resolve({
        data: _.map(res.data.data, item => deserializeMydActivity(item, res.data.included)),
        meta: {
          maxPage: _.ceil(res.data.meta.count / 10),
        },
      })
    }).catch(err => {
      if (err.__CANCEL__ !== true) {
        reject(err)
      }
    })
  })
}

export const deleteMydActivity = (mydActivityId) => {
  return new Promise((resolve, reject) => {
    MydAPI.delete(`/myd/activities/${mydActivityId}`).then(resolve).catch(reject)
  })
}
